module.exports = __webpack_public_path__ + "img/thumbnail_WildBoar_m_leucistic.24180548.png";